/**
 * Num — financial-grade numeric display.
 * Applies tabular-nums + semantic color automatically.
 *
 * Usage:
 *   <Num value="₱48,250.00" tone="positive" />
 *   <Num value={-150} prefix="₱" tone="negative" size="xl" />
 */

const TONE_COLORS = {
  positive: 'var(--num-positive)',
  negative: 'var(--num-negative)',
  neutral:  'var(--num-neutral)',
};

const SIZE_CLASSES = {
  xs: 'text-xs',
  sm: 'text-sm',
  md: 'text-[13px]',
  lg: 'text-base',
  xl: 'text-[28px]',
};

export function Num({
  value,
  tone = 'neutral',
  prefix = '',
  suffix = '',
  size = 'md',
  bold = false,
  className = '',
}) {
  const color = TONE_COLORS[tone] || TONE_COLORS.neutral;
  const sizeClass = SIZE_CLASSES[size] || SIZE_CLASSES.md;
  const fontWeight = bold || size === 'xl' ? '600' : '500';

  return (
    <span
      className={`${sizeClass} ${className}`}
      style={{
        fontVariantNumeric: 'tabular-nums',
        fontFeatureSettings: '"tnum"',
        color,
        fontWeight,
        letterSpacing: 0,
      }}
    >
      {prefix}{value}{suffix}
    </span>
  );
}
